import { ArrowOutward } from '@mui/icons-material';
import {
  Box, Typography,
} from '../../../../1-primative';
import { Card, CardContent } from '../../../../2-component';
import { translateBackend } from '../../../../../assets/i18n/config';

const Link = ({ link, label }: { link: string, label: string }) => (
  <Card sx={{ flex: 1 }} hover onClick={() => window.open(link, '_blank')}>
    <CardContent sx={{ padding: 3 }}>
      <Box display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
        <Typography variant='bodyLarge' weight='bold'>{translateBackend(label)}</Typography>
        <ArrowOutward sx={{ fontSize: 20 }} />
      </Box>

    </CardContent>
  </Card>
);

export const QuickLinks = ({
  options = {
    link1: '',
    link2: '',
    link3: '',
    link4: '',
    link5: '',
    link6: '',
    label1: '',
    label2: '',
    label3: '',
    label4: '',
    label5: '',
    label6: '',
  },
}: {
  options: {
    link1: string;
    link2: string;
    link3: string;
    link4: string;
    link5: string;
    link6: string;
    label1: string;
    label2: string;
    label3: string;
    label4: string;
    label5: string;
    label6: string;
  };
}) => {
  const {
    link1, link2, link3, link4, link5, link6,
    label1, label2, label3, label4, label5, label6,
  } = options;

  return (
    <Box display='flex' flexDirection='row' justifyContent='space-between' alignItems='center' gap={2}>
      {link1 && (
        <Link link={link1} label={label1} />
      )}
      {link2 && (
        <Link link={link2} label={label2} />
      )}
      {link3 && (
        <Link link={link3} label={label3} />
      )}
      {link4 && (
        <Link link={link4} label={label4} />
      )}
      {link5 && (
        <Link link={link5} label={label5} />
      )}
      {link6 && (
        <Link link={link6} label={label6} />
      )}
    </Box>
  );
};
